import template from './customer.all.html';
import controller from './customer.all.controller';
import './customer.all.scss';

let customerallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default customerallComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/all/customer.all.component.js